import React from 'react';
import Flight from '../../../../../Flight';
import { checkoutSegmentGroupToFlightPropsAdapter } from '../../../../../Flight/adapters';
import { OverrideComponent } from '../../../../../renderProps';
import { ThemeProvider, useTheme } from '../../../../../theme';
const ExchangeRefundFlights = ({ orderId, flight }) => {
    const { ExchangeRefundFlights: theme } = useTheme('Entities').Order;
    return (React.createElement("div", { className: theme.root },
        React.createElement(ThemeProvider, { value: {
                DesktopFlightRoute: {
                    DesktopFlightRouteStyles: {
                        flight: theme.flight,
                        selected: theme.selected
                    }
                },
                MobileFlight: {
                    FlightStyles: {
                        flight: theme.flight,
                        flight_selected: theme.selected
                    }
                }
            } }, flight.segmentGroups.map((group, index) => {
            return (React.createElement(OverrideComponent, { key: index, componentProps: Object.assign({}, checkoutSegmentGroupToFlightPropsAdapter(orderId, flight, flight.segmentGroups.find(segmentGroup => segmentGroup.groupId === group.groupId))), component: {
                    renderCheckoutSelectedFlight: Flight
                } }));
        }))));
};
export default ExchangeRefundFlights;
